class FormElementTooltip {
    static render(tooltip) {
        let { title, text, image } = tooltip;
        const { svg } = tooltip;
        if (image) {
            image = `<img src="${image}" />`;
        }
        else {
            image = svg;
        }
        if (typeof image === 'undefined' || image === 'undefined') {
            image = '';
        }
        if (typeof title === 'undefined' || title === 'undefined') {
            title = '';
        }
        if (typeof text === 'undefined' || text === 'undefined') {
            text = '';
        }
        const div = document.createElement('div');
        div.classList.add('modal-container');
        div.classList.add('modal-active');
        div.id = 'tooltip-modal';
        div.innerHTML = `<noindex><div class="modal-content section-modal"><section class="unpad">
        <div class="container"><div class="row"><div class="col-sm-12 col-xs-12">
        <div class="feature feature-1">
        <div class="feature__body boxed boxed--lg boxed--border text-center">
        <div class="modal-close modal-close-cross"></div>
        <div class="tooltip-content">
        <div class="text-center feature feature-6">${image}
        <h3>${title}</h3>
        <p class="text-left">${text}</p></div></div></div></div></div></div></div></section></div></noindex>`;
        document.body.appendChild(div);
        const el = document.querySelector('#tooltip-modal .modal-close, .modal-container');
        if (el) {
            el.addEventListener('click', () => {
                div.parentNode && div.parentNode.removeChild(div);
            });
        }
    }
}
export default FormElementTooltip;
